const UNITS = ["B", "KB", "MB", "GB", "TB"];

export function formatBytes(bytes, fractionDigits = 2) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value <= 0) return "0 B";

  let size = value;
  let i = 0;
  while (size >= 1024 && i < UNITS.length - 1) {
    size /= 1024;
    i++;
  }
  const rounded =
    i === 0 ? Math.round(size) : Number(size.toFixed(fractionDigits));
  return `${rounded} ${UNITS[i]}`;
}
